import HeroSlider from "components/home/HeroSlider";
import StatsBar from "components/home/StatsBar";
import GalleryPreview from "components/home/GalleryPreview";
import ManagementPreview from "components/home/ManagementPreview";
import ConnectEdSection from "components/home/ConnectEdSection";
import Reveal from "components/shared/Reveal";

export default function HomePage() {
  return (
    <div className="animate-fadeIn">
      {/* The journey strip now lives INSIDE the slider (overlaid on desktop,
          stacked beneath on mobile) so both are visible without scrolling. */}
      <HeroSlider />
      <StatsBar />
      <Reveal>
        <ManagementPreview />
      </Reveal>
      <Reveal>
        <GalleryPreview />
      </Reveal>
      <Reveal>
        <ConnectEdSection />
      </Reveal>
    </div>
  );
}
